import { render, staticRenderFns } from "./add-specification.vue?vue&type=template&id=41e8e4db&scoped=true"
import script from "./add-specification.vue?vue&type=script&lang=js"
export * from "./add-specification.vue?vue&type=script&lang=js"
import style0 from "./add-specification.vue?vue&type=style&index=0&id=41e8e4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e8e4db",
  null
  
)

export default component.exports